<template>
  <div class="carousel__cta">SCROLL FOR RECIPES</div>
  <div class="animated-arrow">
    <img class="animated-arrow__img" src="../.././public/misc/arrow--gold.svg">
  </div>
  <div class="carousel__header">FIND A PIMM’S FOR EVERY SUMMER MOMENT</div>
  <div :class="`component__carousel--${props.iteration}`">
  <div class="carousel__bg">
    <div class="carousel__wrapper">
      <div :class="carouselIteration">
        <div
          class="carousel__product"
          v-for="item in carousel[props.iteration]"
          :key="item"
        >
          <a class="cswidget" :data-asset-id="item.dataAssetId">
            <div>
              <img class="carousel__img--product opacity--0" v-if="item.button" :src="item.img" />
            </div>
            <div class="carousel__h1 px--20" v-if="item.button" v-html="item.title"></div>
            <div class="carousel__h2 px--20 mb--20" v-if="item.button" v-html="item.sub"></div>
            <button class="carousel__button cswidget" v-if="item.button" data-asset-id="2304" :data-product-sku="item.skuArr" data-action="csWidgetOpen">Buy now</button>
            <div class="carousel__h1 px--20" v-if="!item.button">
              <div class="carousel__slide-copy">To enjoy a classic Pimm’s &amp; lemonade premix, drink chilled from the can or serve over ice and with fruit garnishes.</div>
              <div class="carousel__arrow-wrapper"><img class="carousel__svg--arrow" src="../.././public/misc/arrow--gold.svg"></div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script setup>
import gsap from 'gsap';
const props = defineProps({
  iteration: {
    type: String,
    default: "1",
  },
});
var carouselIteration = "carousel--" + props.iteration;
var carousel = {
  1: {
    1: {
      title: "PIMM’S NO.1",
      sub: '70CL, ABV 25%',
      img: "./products/prod--1.png",
      url: "",
      dataAssetId: "",
      button: true,
      skuArr: "764611, 764651, 768819"
    },
    2: {
      title: "PIMM’S&nbsp;SUNDOWNER",
      sub: '70CL, ABV 18%',
      img: "./products/prod--2.png",
      url: "",
      dataAssetId: "",
      button: true,
      skuArr: "768819, 764611, 764651"
    },
    3: {
      title: "PIMM’S NO.1",
      sub: '1L, ABV 25%',
      img: "./products/prod--3.png",
      url: "",
      dataAssetId: "",
      button: true,
      skuArr: "764651, 764611, 768819"
    },
    4: {
      title: "",
      sub: '',
      img: "",
      url: "",
      dataAssetId: "",
      button: false
    },
    5: {
      title: "PIMM’S NO.1 PREMIX",
      sub: '25CL, ABV 5.4%',
      img: "./products/prod--4.png",
      url: "",
      dataAssetId: "",
      button: true,
      skuArr: "720392, 770162, 772986, 770161, 772987"
    },
    6: {
      title: "PIMM’S NO.1 PREMIX X&nbsp;4",
      sub: '25CL, ABV 5.4%',
      img: "./products/prod--5.png",
      url: "",
      dataAssetId: "",
      button: true,
      skuArr: "770162, 720392, 772986, 770161, 772987"
    },
    7: {
      title: "PIMM’S NO.1 PREMIX X&nbsp;10",
      sub: '25CL, ABV 5.4%',
      img: "./products/prod--6.png",
      url: "",
      dataAssetId: "",
      button: true,
      skuArr: "770161, 772986, 720392, 770162, 772987"
    }
  }
};
$(document).ready(function () {
  gsap.set('.animated-arrow__img', {
    opacity: 0,
    y: -30
  })
  var tlArrow = gsap.timeline({repeat: -1});
  tlArrow.to('.animated-arrow__img', {
    duration: .5,
    y: 0,
    opacity: 1
  })
  .to('.animated-arrow__img', {
    duration: .5,
    delay: 1,
    y: 30,
    opacity: 0,
    onComplete: () => {
      gsap.set('.animated-arrow__img', {
        y: -30
      })
    }
  })
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .prepend(
      `<img class="carousel__previous--${props.iteration}" src="./misc/circle-chevron.svg" width="40" style="position: absolute;top: calc(50% - 18px);z-index: 1150;left: 20px;transform:rotate(180deg);-webkit-filter: drop-shadow(0px 0px 10px rgba(0,0,0,0.5));filter: drop-shadow(0px 0px 10px rgba(0,0,0,0.5);">`
    );
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .append(
      `<img class="carousel__next--${props.iteration}" src="./misc/circle-chevron.svg" width="40" style="position: absolute;top: calc(50% - 18px);z-index: 1150;right: 20px;-webkit-filter: drop-shadow(0px 0px 10px rgba(0,0,0,0.5));filter: drop-shadow(0px 0px 10px rgba(0,0,0,0.5)">`
    );

  $("." + carouselIteration).slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow: $(".carousel__previous--" + props.iteration),
    nextArrow: $(".carousel__next--" + props.iteration),
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1650,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.carousel__header {
  color: $color--red;
  font-size: 60px;
  line-height: 64px;
  @media screen and(max-width: 767px) {
    font-size: 34px;
    line-height: 34px;
    padding: 0px 20px;
  }
}
.csWidget .CSBuyNowButton a:hover {
  background-color: rgba(0,0,0,0) !important;
}
.csWidgetBuynow {
  font-size: 20px !important;
}
.csWidgetTitle h1 {
  font-size: 22px !important;
  line-height: 22px;
  color: $color--red !important;
}
@media (min-width: 768px) {

  .csWidgetModal-dialog {
    height: 100% !important;
  }
}
@media (max-width: 768px) {
  .csWidgetModal-dialog {
    height: 100% !important;
  }
  .csWidgetModal-content {
    height: 100% !important;
    overflow: scroll !important;
  }
  .cs-t1 .csWidgetModal-content {
    border: 5px solid $color--red !important;
    border-radius: 0px !important;
  }
}
.component__carousel--1 {

  .carousel__bg {
    height: 800px;
    position: relative;

    @media screen and(max-width: 600px) {
      background-size: 320%;
    }
    @media screen and(max-width: 321px) {
      background-size: 350%;
    }
  }
  .carousel__wrapper {
    height: 100%;
    margin: auto;
    padding-top: 70px;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 100;
  }
  .carousel {
    width: 100%;
    margin: 0px auto;
  }
  .carousel__product {
    padding: 0px 20px;
    width: 100%;
  }
  .wrapper .slick-dots li button:before {
    font-size: 20px;
    color: #000000;
  }
  .slick-arrow:before {
    color: #ffffff;
  }

  .carousel__h1 {
    color: #222222;
    font-size: 26px;
    font-weight: 900;
    line-height: 32px;
    max-width: 700px;
  }
  .carousel__h2 {
    color: $color--gold;
    font-size: 18px;
    font-weight: 900;
    line-height: 22px;
    max-width: 700px;
  }

  .carousel__button {
    background: $color--red;
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 2px;
    padding: 15px;
    text-transform: uppercase;
  }
  .carousel__img--product {
    margin: auto;
    max-width: 200px;
    width: 100%;
  }
  .carousel__slide-copy {
    color: $color--gold;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    padding-top: 200px;
    text-transform: none;
  }
  .carousel__arrow-wrapper {
    padding-top: 0px;
    text-align:  center;
    width: 100%;
  }
  .carousel__svg--arrow {
    margin: auto;
    width: 50px;
  }
}
.carousel__cta {
  border-radius: 7px;
  background: $color--gold;
  color: #ffffff;
  font-size: 18px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  padding: 10px 0px;
  width: 170px;
}

</style>